<template>
  <div :class="`right-slider-menu ${isMenuOpen ? 'expand' : ''}`">
    <div class="main">
      <img
        class="cross_icon"
        src="/img/cross-x_icon.svg"
        alt="cross"
        @click="emitCloseMenu"
      />
      <div class="menu-content">
        <LanguagePicker
          :is-mobile="false"
          class="language-picker menu-content-item"
        />
        <LanguagePicker
          :is-mobile="true"
          class="language-picker-mobile menu-content-item"
        />
      </div>
      <span class="copyright"
        >&copy; CyberSystem {{ new Date().getFullYear() }}</span
      >
    </div>
  </div>
</template>

<script lang="ts" setup>
import LanguagePicker from "./languagePicker.vue";

const emit = defineEmits(["close"]);
defineProps({
  isMenuOpen: { type: Boolean, default: true },
});

const emitCloseMenu = () => {
  emit("close");
};
</script>

<style scoped>
.right-slider-menu {
  max-width: 360px;
  width: 0px;
  height: 100%;
  position: fixed;
  top: 0;
  right: 0;
  z-index: 1100; /* > z-index modal = 1061 */
  background: #ffffff;
  -webkit-transition: right 0.2s ease;
  -moz-transition: right 0.2s ease;
  -o-transition: right 0.2s ease;
  -ms-transition: right 0.2s ease;
  transition: right 0.2s ease;
  overflow-x: hidden;
}

.right-slider-menu.expand {
  width: 100%;
}

.right-slider-menu.expand .main {
  display: flex;
  flex-direction: column;
  position: relative;
  width: 100%;
  height: 100%;
}

.right-slider-menu .main .cross_icon {
  width: 16.09px;
  height: 16.09px;
  margin-top: 30px;
  margin-right: 40px;
  margin-left: auto;
  cursor: pointer;
}

.right-slider-menu .copyright {
  position: absolute;
  bottom: 30px;
  left: 40px;
  /* text/text-14_med */

  font-family: "Poppins";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 100%;
  /* identical to box height, or 14px */

  /* UI/dark */

  color: #231f20;
  width: 150px;
}

.menu-content {
  display: flex;
  justify-content: flex-end;
  margin-right: 40px;
}

.menu-content-item {
  margin-top: 30px;
}

.language-picker {
  display: block;
}

.language-picker-mobile {
  display: none;
}

@media (max-width: 500px) {
  .language-picker {
    display: none;
  }

  .language-picker-mobile {
    display: block;
  }
}
</style>
